import { Component, Input } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { ContentReadyEvent } from "devextreme/ui/html_editor";

@Component({
  selector: "brd-module-editor",
  templateUrl: "./module-editor.component.html",
  styleUrl: "./module-editor.component.less"
})
export class ModuleEditorComponent {
  @Input() moduleFormGroup!: FormGroup;
  private allowedAttributes = ["align", "bold", "italic", "underline", "strike", "color", "size"];

  protected onHtmlEditorContentReady(event: ContentReadyEvent): void {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    event.component.getQuillInstance().clipboard.addMatcher(Node.ELEMENT_NODE, (_: HTMLElement, delta: any) => {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      delta.ops = delta.ops.map((op: any) => {
        if (op.attributes) {
          op.attributes = this.filterAlloweAttributes({ ...op.attributes });
        }
        return op;
      });

      return delta;
    });
  }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  private filterAlloweAttributes(attributes: any): any {
    return Object.keys(attributes)
      .filter(key => this.allowedAttributes.includes(key))
      .reduce((obj, key) => {
        obj[key] = attributes[key];
        return obj;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
      }, {} as any);
  }
}
